export default {
  allowLassoOnContainer: false,
  overrideProportionalResize: true,
  allowConnectToDB: true,
};
